import { AuthError } from '../interface';

export const authError = {
    isInvalidEmail: (error: any) => error.code === AuthError.INVALID_EMAIL,
    isInvalidPassword: (error: any) => error.code === AuthError.WRONG_PASSWORD,
    isUserNotFound: (error: any) => error.code === AuthError.USER_NOT_FOUND,
    isTooManyRequest: (error: any) => error.code === AuthError.TOO_MANY_REQUESTS,
    isUserMismatch: (error: any) => error.code === AuthError.USER_MISMATCH,
    isAlreadyInUse: (error: any) => error.code === AuthError.EMAIL_ALREADY_IN_USE,
    isWeakPassword: (error: any) => error.code === AuthError.WEAK_PASSWORD,
    isUnknownError: (error: any) => error.code === AuthError.UNKNOWN_ERROR,
};
